import { r as w, c as v } from "../lit-element-8JrrHldg.js";
import { p as g } from "../pwcProperty-CTLG9yrF.js";
import { c as d } from "../clsx-DB4S2d7J.js";
import { n as y } from "../property-4FoNj0Pi.js";
import { r as _ } from "../state-D4BCZ2JK.js";
import { u as $, s as h } from "../static-CPcCYSrK.js";
var z = Object.defineProperty, C = Object.getOwnPropertyDescriptor, a = (e, t, o, s) => {
  for (var n = s > 1 ? void 0 : s ? C(t, o) : t, c = e.length - 1, r; c >= 0; c--)
    (r = e[c]) && (n = (s ? r(t, o, n) : r(n)) || n);
  return s && n && z(t, o, n), n;
}, b = (e, t, o) => {
  if (!t.has(e))
    throw TypeError("Cannot " + o);
}, P = (e, t, o) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, o);
}, f = (e, t, o) => (b(e, t, "access private method"), o), p, m;
const l = {
  color: "currentColor",
  size: "1.25em"
};
let i = class extends w {
  constructor() {
    super(), P(this, p), f(this, p, m).call(this);
  }
  createRenderRoot() {
    return this;
  }
  updated(e) {
    e.has("icon") && f(this, p, m).call(this);
  }
  render() {
    const {
      size: e = l.size,
      color: t = l.color,
      inline: o,
      svgContent: s
    } = this;
    let n = e && e != null && !isNaN(+e) ? `${e}px` : e;
    return `${n}`.length || (n = l.size), $`
      <div
        class=${d("PwcIcon", {
      "PwcIcon--inline": o,
      "PwcIcon--color": s == null ? void 0 : s.color
    })}
        style="--size:${n};--color:${t}"
      >
        ${s == null ? void 0 : s.content}
      </div>
    `;
  }
};
p = /* @__PURE__ */ new WeakSet();
m = async function() {
  var c;
  if (((c = this.svgContent) == null ? void 0 : c.key) === this.icon)
    return;
  const e = `pi-${this.icon}`;
  if (!!/^[a-z0-9-_]*$/.test(e) && customElements.get(e)) {
    this.svgContent = {
      key: this.icon,
      color: !1,
      content: h(`<${e}></${e}>`)
    };
    return;
  }
  const o = `${i.tagName}-${this.icon}`;
  if (!!/^[a-z-_]*$/.test(o) && customElements.get(o)) {
    console.warn(
      "[@ecoonline/prism-web-components] Deprecation warning: please note that in the next major version, icons will no longer be available from the prism-web-components package directly. We encourage you to begin using the prism-icons package as soon as possible. See https://www.npmjs.com/package/@ecoonline/prism-icons."
    ), this.svgContent = {
      key: this.icon,
      color: !1,
      content: h(`<${o}></${o}>`)
    };
    return;
  }
  const n = `https://cdn.ecoonline.com/assets/icons/${this.icon}.svg`;
  try {
    console.warn(
      "[@ecoonline/prism-web-components] Deprecation warning: please note that in the next major version, the logomarks will no longer be available in pwc-icon component. We encourage you to begin using the new pwc-logomark component as soon as possible."
    );
    const r = await fetch(n);
    if (r.status !== 200)
      throw new Error();
    const u = await r.text();
    this.svgContent = {
      key: this.icon,
      color: /_color$/.test(this.icon),
      content: h(u)
    };
  } catch {
    this.svgContent = {
      key: this.icon,
      color: !1,
      content: null
    };
  }
};
i.tagName = "pwc-icon";
a([
  y({
    type: String,
    reflect: !0
  })
], i.prototype, "icon", 2);
a([
  g({ type: Boolean, default: !1 })
], i.prototype, "inline", 2);
a([
  g({ type: String, default: l.color })
], i.prototype, "color", 2);
a([
  g({ type: String, default: l.size })
], i.prototype, "size", 2);
a([
  _()
], i.prototype, "svgContent", 2);
i = a([
  v("pwc-icon")
], i);
export {
  i as PwcIcon
};
